import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ResidualFileUpload } from "../../../../../../api";
import DeleteIcon from "../../../../../assets/svg/icons/common/delete";
import ExcelFile from "../../../../../assets/svg/icons/common/excel-file";
import ButtonIcon from "../../../../../components/ButtonIcon/ButtonIcon";
import MonthPicker from "../../../../../components/form/month-picker";
import Modal from "../../../../../components/modal";
import useOrganizationStore from "../../../../../stores/organization";
import styles from "./styles.module.scss";

const FileItem = ({ name, size, onDelete }) => (
  <div className={styles.file}>
    <div className={styles.fileIcon}>
      <ExcelFile />
    </div>
    <div className={styles.fileInfo}>
      <span className={styles.fileName}>{name}</span>
    </div>
    {onDelete ? (
      <div className={styles.fileDeleteIcon} onClick={onDelete}>
        <DeleteIcon />
      </div>
    ) : (
      ""
    )}
  </div>
);

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

function AddResidualsModal({ open, onClose, file, clearFile }) {
  const [submitting, setSubmitting] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationId,
  );

  const handleSubmit = () => {
    if (!file) {
      toast.error("Please select a file to upload", { duration: 5000 });
      return;
    }

    if (!selectedMonth) {
      toast.error("Please select a month", { duration: 5000 });
      return;
    }

    toast.loading("Uploading...", { duration: 10000 });
    setSubmitting(true);

    const reader = new FileReader();

    reader.onabort = () => {
      toast.dismiss();
      toast.error("File upload aborted", { duration: 5000 });
      setSubmitting(false);
    };

    reader.onerror = () => {
      toast.dismiss();
      toast.error("File upload failed", { duration: 5000 });
      setSubmitting(false);
    };

    reader.onload = (e) => {
      const binaryStr = reader.result;
      const base64EncodedStr = arrayBufferToBase64(binaryStr);
      const fullMonthName = moment(selectedMonth, "MMM").format("MMMM");

      ResidualFileUpload({
        organization_id: selectedOrganizationId,
        base64EncodedStr,
        month: fullMonthName,
        CurrentYear: selectedYear,
      })
        .then((response) => {
          toast.dismiss();
          if (response.success) {
            toast.success("File uploaded successfully", { duration: 5000 });
            onClose();
            clearFile();
            setSelectedMonth(null);
            setSelectedYear(new Date().getFullYear());
          } else {
            toast.error("Error while uploading file", { duration: 5000 });
          }
          setSubmitting(false);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          toast.dismiss();
          toast.error("Error while uploading file", { duration: 5000 });
          setSubmitting(false);
        });
    };

    reader.readAsArrayBuffer(file);
  };

  useEffect(() => {
    if (open) {
      setSelectedMonth(null);
      setSelectedYear(new Date().getFullYear());
    }
  }, [open]);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header={"Select residuals' period"}
      headingCenteredSpaced
      size="sm"
    >
      <div className={styles.modalBody}>
        {file && (
          <>
            <div className={styles.fileList}>
              <FileItem
                name={file.name}
                onDelete={() => {
                  onClose();
                  clearFile();
                }}
              />
            </div>
            <div className={styles.monthPicker}>
              <MonthPicker
                onChange={(month, year) => {
                  setSelectedMonth(month);
                  setSelectedYear(year);
                }}
              />
            </div>
          </>
        )}
      </div>

      <div className={styles.modalFooter}>
        <ButtonIcon textColor="#254FE2" onClick={onClose}>
          Cancel
        </ButtonIcon>
        <ButtonIcon
          bgColor={"#4C70EF"}
          textColor="#FFF"
          disabled={submitting || !file || !selectedMonth}
          onClick={handleSubmit}
        >
          {submitting ? "Uploading..." : "Submit"}
        </ButtonIcon>
      </div>
    </Modal>
  );
}

export default AddResidualsModal;
